export const extractSrcUrl = (input) => {
  const match = input.match(/src\s*=\s*["']?([^"'\s>]+)["']?/i);
  return match ? match[1] : null;
};

export const isValidHttpUrl = (value) => {
  try {
    const url = new URL(value);
    return url.protocol === 'http:' || url.protocol === 'https:';
  } catch {
    return false;
  }
};

/**
 * Resolves a tag code input to its effective URL.
 * If input is a direct URL, returns it as-is.
 * If input is an HTML tag with a src= attribute, extracts and returns the src URL.
 */
export const resolveTagCodeUrl = (value) => {
  if (!value) return value;
  const trimmed = value.trim();
  if (isValidHttpUrl(trimmed)) return trimmed;
  const srcUrl = extractSrcUrl(trimmed);
  return srcUrl || trimmed;
};

/**
 * Ant Design Form validator for Third Party Tag Code fields.
 * Accepts a plain URL or an HTML tag containing a valid src= URL.
 */
export const validateTagCode = (_, value) => {
  if (!value || !value.trim()) return Promise.resolve();
  const trimmed = value.trim();
  if (isValidHttpUrl(trimmed)) return Promise.resolve();
  const srcUrl = extractSrcUrl(trimmed);
  if (srcUrl && isValidHttpUrl(srcUrl)) return Promise.resolve();
  return Promise.reject(
    new Error('Tag Code must be a valid URL or a tag containing a valid src= URL')
  );
};
